import React, { useState } from 'react'
import { Tooltip, Badge } from 'reactstrap'

const ExclusionCell = ({ row, rowIndex }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false)

  const toggle = () => setTooltipOpen(!tooltipOpen)
  const excludedString = row.selectedExcludedAdditions
    ? row.selectedExcludedAdditions.map((c) => c.label).join('\r\n')
    : ''

  return (
    <span style={{ cursor: 'pointer' }}>
      <span id={`additionToolTip${rowIndex}`}>
        {row.selectedExcludedAdditions && row.selectedExcludedAdditions.length ? (
          <b>{row.selectedExcludedAdditions.length}</b>
        ) : (
          0
        )}{' '}
        additions
      </span>
      <Tooltip placement="top" isOpen={tooltipOpen} target={`additionToolTip${rowIndex}`} toggle={toggle}>
        {excludedString ? excludedString : 'None'}
      </Tooltip>
      <Badge
        style={{
          float: 'right',
          marginRight: '20px',
          marginTop: '3px',
        }}
        color="secondary"
      >
        edit
      </Badge>
    </span>
  )
}

export default ExclusionCell
